import Pagination from "@/components/share/pagination";
import Update from "../edit";
import Service from "../../../../utils/api/service";
import Helper from "../../../../utils/global/func";
import TableLoading from "./../../../../components/share/table-loading";
import NoItem from "./../../../../components/share/table-no-item";
import { mapState } from "vuex";

export default {
  name: "ListOption",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      fields: {
        id: "",
        index: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      },
      data: {
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
    };
  },
  components: {
    Pagination,
    Update,
    TableLoading,
    NoItem,
  },
  created() {
    this.getOptions();
  },
  watch: {
    "$route.fullPath": function () {
      this.getOptions();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getOptions() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      let params = this.$helper.queryParam(setQuery);

      Service.getAllOption(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getOptions();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.options = [];
            this.$toasted.show(response.message);
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          if (response.data.length > 0) {
            this.isNoData = false;
            this.data.options = response.data;
            this.data.pagination = Helper.calculatePagination(response.meta);
          } else {
            this.data.options = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    htmlToText(html) {
      return Helper.convertToPlain(html);
    },

    popupModal(index) {
      this.fields.index = index;
      this.display.modal.delete.show = true;
    },

    deleteOption() {
      this.isDeleting = true;
      let optionId = this.data.options[this.fields.index].id;
      Service.deleteOption(optionId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteOption();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.options.splice(this.fields.index, 1);
          this.data.pagination.total -= 1;
          this.$toasted.show("Option has been deleted.");
          this.closeModal();
        }
      });
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      };
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },
  },
};
